import { render } from "./NovaRequisicaoMaterialComponent.vue?vue&type=template&id=c73163b0&scoped=true"
import script from "./NovaRequisicaoMaterialComponent.vue?vue&type=script&lang=js"
export * from "./NovaRequisicaoMaterialComponent.vue?vue&type=script&lang=js"

import "./NovaRequisicaoMaterialComponent.vue?vue&type=style&index=0&id=c73163b0&scoped=true&lang=css"
import "./NovaRequisicaoMaterialComponent.vue?vue&type=style&index=1&id=c73163b0&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73163b0"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QSelect,QField});
